import { Slot } from "@radix-ui/react-slot";
import { FC } from "react";

import { cn } from "@/lib/utils";

import { ButtonProps } from "./types";
import { variants } from "./variants";

export const Button: FC<ButtonProps> = ({
  className,
  variant,
  size,
  asChild = false,
  ...props
}) => {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(variants({ variant, size, className }))}
      {...props}
    />
  );
};
